import { Injectable } from '@angular/core';
import { FormGroup } from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class PassValidationService {

  constructor() { }
  passValidator(nueva: string, confirmNueva: string) {
    return (formgroup: FormGroup) => {
      const nuevaControl = formgroup.controls[nueva];
      const confirmNuevaControl = formgroup.controls[confirmNueva];

      if (!nuevaControl || !confirmNuevaControl) {
        return null;
      }

      if (
        confirmNuevaControl.errors &&
        !confirmNuevaControl.errors.passDistinta
      ) {
        return null;
      }

      if (nuevaControl.value !== confirmNuevaControl.value) {
        confirmNuevaControl.setErrors({ passDistinta: true });
      } else {
        confirmNuevaControl.setErrors(null);
      }
      return;
    };
  }
}
